import { Button, TextField, Typography } from "@mui/material"
import { StyledLoginForm } from "./LoginForm.styled"
import { useForm } from "react-hook-form";
import { LoginDto } from "../../Models/Types";
import { language } from "../../Globals/Constants";
import { useProfile } from "../../stores/useProfile";

export const LoginForm = () => {
const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginDto>({});

  const { fetchProfile } = useProfile();

  const onSubmit = async (data: LoginDto) => {
    await fetchProfile(data);
  };


    return <StyledLoginForm onSubmit={handleSubmit(onSubmit)}>
    <Typography variant="h2">Login</Typography>
        <Typography variant="h4">Email</Typography>
      <TextField
        {...register("username", {
          required: language.requiredInput,
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: language.invalidEmail,
          },
        })}
        error={!!errors.username}
        helperText={errors?.username?.message}
        fullWidth
      />
      <Typography variant="h4">
        Wachtwoord
      </Typography>
      <TextField
        type="password"
        {...register("password", {
          required: language.requiredInput,
        })}
        error={!!errors.password}
        helperText={errors?.password?.message}
      />
      <Button type="submit" variant="outlined">
        Inloggen
      </Button>
    </StyledLoginForm>
}